// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"604":"3ed32174","721":"84c05271"}[chunkId] + ".chunk.css";
};